<template>
  <div>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              Member Name
            </th>
            <th class="text-left"
              v-if="project.status !== 'APPROVED' && (role === 'CLUB_PRESIDENT' || role === 'CLUB_SECRETARY' || role === 'CLUB_TREASURER' || role === 'CLUB_ADMINISTRATOR')">
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in participants" :key="item.uuid">
            <td v-if="item.member">{{ item.member.display_name }}</td>
            <td v-else>-</td>
            <td><v-icon color="red" @click="deleteParticipant(item.uuid)">
                mdi-delete-circle
              </v-icon></td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  name: "ParticipantsList",

  props: ["participants", "project"],
  components: {},

  data: () => ({
    loading: false,
    role: localStorage.getItem('role') || null
  }),

  methods: {
    submit() {
      this.loading = true;
    },
    deleteParticipant(id) {
      this.$emit('deleteParticipant', id);
    }
  },
};
</script>
